import { mapFinalCalculation, RawFinalCalculation } from '~/Api/User/ProductGroup/RoMaxPrice/mapFinalCalculation';
import { mapProduct, RawProduct } from '~/Api/User/ProductGroup/RoMaxPrice/mapProduct';
import { Reference } from '~/Api/User/ProductGroup/RoMaxPrice/Reference';
import { RoMaxPrice } from '~/Api/User/ProductGroup/RoMaxPrice/RoMaxPrice';

interface RawReference {
	decisionNumber: string | null;
	packageSize: number;
	referenceBasketVersion: string;
	historicProductDataViewDate: string | null;
	referencedProductType: string | null;
	fxUpdatePrice: number | null;
	fxUpdatePriceEnabled: boolean;
	prgPrbPrice: number | null;
	prgPrbPriceEnabled: boolean;
	priPrice: number | null;
	priPriceEnabled: boolean;
	lossOfExclusivity: string | null;
	gtin: string | null;
}

export interface RawRoMaxPrice {
	finalCalculation: RawFinalCalculation;
	_links: { [key: string]: string };
	products: RawProduct[];
	reference: RawReference;
}

export const mapRoMaxPrice = (roMaxPrice: RawRoMaxPrice): RoMaxPrice => {
	return new RoMaxPrice(
		new Reference(
			roMaxPrice.reference.packageSize,
			roMaxPrice.reference.referenceBasketVersion,
			roMaxPrice.reference.historicProductDataViewDate !== null
				? new Date(roMaxPrice.reference.historicProductDataViewDate)
				: null,
			roMaxPrice.reference.referencedProductType,
			roMaxPrice.reference.decisionNumber,
			roMaxPrice.reference.fxUpdatePrice,
			roMaxPrice.reference.fxUpdatePriceEnabled,
			roMaxPrice.reference.prgPrbPrice,
			roMaxPrice.reference.prgPrbPriceEnabled,
			roMaxPrice.reference.priPrice,
			roMaxPrice.reference.priPriceEnabled,
			roMaxPrice.reference.lossOfExclusivity,
			roMaxPrice.reference.gtin
		),
		roMaxPrice.products.map(mapProduct),
		mapFinalCalculation(roMaxPrice.finalCalculation),
		roMaxPrice._links
	);
};
